import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { useSince } from '@platform/features/users/inbox/useSince';
import { WorkspaceLink } from '@platform/navigation';
import { auditText } from './auditText';
import type { IRecentChangeRowProps } from './IRecentChangeRowProps';

/**
 * Рядок «Нещодавніх змін» (прототип v4 admRecent): хто (600) і коли (12px праворуч), зміна в один рядок («Статус: До виконання → В роботі»,
 * «Коментар: …», «пов’язано з 9»), «Тип номер · назва» 12px приглушено; клік відкриває історію запису (у просторі запису).
 */
export function RecentChangeRow({ item, recordLabel }: IRecentChangeRowProps) {
  const { t } = useTranslation();
  const since = useSince();
  const r = item.record;
  const to = r.id && r.module && r.recordType ? routes.record(r.module, r.recordType, r.id, 'history') : routes.home();
  return (
    <WorkspaceLink className="ad-change" ws={r.workspaceId} to={to}>
      <span className="ad-change__top"><strong>{item.actor?.name ?? ''}</strong><span className="ad-change__when">{since(item.at)}</span></span>
      <span className="ad-change__text">{auditText(item, t)}</span>
      <span className="ad-change__meta" title={r.display ?? undefined}>{recordLabel}</span>
    </WorkspaceLink>
  );
}
